import React, { useEffect, useState } from "react";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginRoot from "./Screens/LoginRegister/LoginRoot.js";
import { useMsal } from "@azure/msal-react";
import { authenticateUserBasedOnValidToken } from "./redux/API/api_Login.js";
import { useAuth } from "react-oidc-context";
import Header from "./components/Header/Header.js";
import {
  authUserAction,
  saveAccessTokenAction,
  saveAzureTokenAction,
  storeUserDetailsAction,
} from "../src/redux/Actions/actions";
// import {IdleTimerComponent as IdleTimer} from "react-idle-timer";
import Loading from "./components/Loading/Loading.js";
import {
  AdminRoute,
  DesignerRoute,
  SalesRoute,
  Saleslist,
} from "./Routes/MasterRoute.js";
import UnauthorizedAccess from "./pages/UnauthorizedAccess/UnauthorizedAccess.js";
import SnackbarCustom from "./components/Snackbar/Snackbar.js";

function App() {
  const auth = useAuth();
  const dispatch = useDispatch();
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [isLoader, setIsLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const token = useSelector((state) => state.saveTokenReducer.token);
  const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const keyVal = useSelector((state) => state.authUserReducer.gid);
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };
  // snackbar close
  const handleSnackClose = (e) => {
    setOpen(false);
  };

  const handleClose = (e, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setDialogOpen(false);
  };

  const handleDialogOpen = (text) => {
    setDialogContent(text);
    setDialogOpen(true);
  };

  function sessionExpire(auth, dispatch) {
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname;
    window.history.pushState({ path: newurl }, "", `/`);
    localStorage.clear();
    sessionStorage.clear();
    if (auth !== undefined) {
      dispatch(storeUserDetailsAction(""));

      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    window.location.href = "/";
  }

  function authenticateUserWithGID(gid) {
    authenticateUserBasedOnValidToken(dispatch, activeAccount.idToken, gid)
      .then((response) => {
        if (response) {
          setDialogOpen(false);
          setIsLoader(false);
        } else {
  
          handleSnackOpen("This page is restricted, and you do not have permission to view it. Please contact the administrator for further assistance", "error");
          setIsLoader(false);
          localStorage.clear();
          //setDialogOpen(true);
        }
      })
      .catch((error) => {
        handleSnackOpen("Error while log in", "error");
        setIsLoader(false);
        localStorage.clear();
      //  setDialogOpen(true);
      });
  }

  useEffect(() => {
    console.log("use effect app");
    if (activeAccount) {
      setIsLoader(true);
      if (activeAccount) {
        let gid = accounts[0].idTokenClaims.gid;
        dispatch(authUserAction(gid));
        dispatch(saveAzureTokenAction(activeAccount.idToken));
        authenticateUserWithGID(gid);
      }
    } else {
      setIsLoader(false);
    }
  }, [accounts]);

  return (
    <Router>
      {auth.isLoading || isLoader ? (
        <Loading />
      ) : (userDetails && userDetails.roleId > 0) || auth.user ? (
        <div className="potts-master-block">
          <Header></Header>
          <main className="main-component">
            {userDetails.roleId ? (
              <>
    
                {userDetails.roleId == 1 && AdminRoute}

                {userDetails.roleId == 2 && SalesRoute}

                {userDetails.roleId == 3 && DesignerRoute}

                {userDetails.roleId == 4 && Saleslist}
              </>
            ) : (
              <>
                <Navigate from="/?Code*" to="/" />
                <Routes>
                  <Route path="/" element={<UnauthorizedAccess />} />
                </Routes>
              </>
            )}
          </main>
        </div>
      ) : (
        <main className="main-component">
          <Navigate from="/signin-oidc*" to="/" />
          <Routes>
            <Route path="/" element={<LoginRoot />} />
          </Routes>
        </main>
      )}

      {/* <div>
        <IdleTimer
          timeout={1000 * 60 * 15}
          onIdle={sessionExpire}
          debounce={250}
        />
      </div> */}

      <SnackbarCustom
        open={open}
        message={snackMessage}
        alertType={alertType}
        handleClose={handleSnackClose}
      />
    </Router>
  );
}

export default App;
